@if (showSpinner) {
<app-loader> </app-loader>
}
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  <div class="container-fluid mb-4 pl-4 pr-4" *ngIf="isavailablefeature('isView')">
    <!-- Combined Header and Filter Section -->
    <div class="combined-header-filter-section" [ngClass]="{ 'dark-mode': selectedMode === 'dark' }">
      <!-- Header Content -->
      <div class="header-content">
        <div class="title-section">
          <div class="title-wrapper">
            <div class="title-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
            </div>
            <div class="title-text-container">
              <h1 class="main-title">Attendance Management</h1>
              <p class="subtitle">
                Monitor and manage employee attendance records
              </p>
            </div>
          </div>
        </div>

        <div class="action-buttons">
          @if (isavailablefeature("isReport")) {
          <button type="button" class="modern-btn request-btn" routerLink="/user-attendance-list">
            <div class="btn-content">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
              </svg>
              <span>Attendance Requests</span>
              @if (Attendanceotificaton.total_count != 0) {
              <span class="notification-badge">{{
                Attendanceotificaton.total_count
                }}</span>
              }
            </div>
          </button>
          }

          @if (isavailablefeature("isSheet")) {
          <button type="button" class="modern-btn upload-btn" data-toggle="modal" data-target="#okModal"
            style="display: none">
            <div class="btn-content">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14,2 14,8 20,8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
                <polyline points="10,9 9,9 8,9"></polyline>
              </svg>
              <span>Add Sheet</span>
            </div>
          </button>
          }
          <input type="file" id="fileInput" style="display: none" (change)="onFileChange($event)" />
        </div>
      </div>

      <!-- Filter Toggle Button with Action Buttons -->
      <div class="filter-toggle-section">
        <button class="filter-toggle-btn" (click)="toggleFilterSection()" [attr.aria-expanded]="isFilterExpanded">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="filter-icon">
            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
          </svg>
          <span>{{ isFilterExpanded ? "Hide Filters" : "Show Filters" }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="chevron-icon"
            [class.rotated]="isFilterExpanded">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </button>

        <div class="action-controls">
          <button type="button" class="control-btn apply-btn" (click)="attendanceFiter()">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            Apply Filters
          </button>

          <button type="button" class="control-btn reset-btn" (click)="resetfilter()">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="1 4 1 10 7 10"></polyline>
              <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>
            </svg>
            Reset
          </button>

          <button type="button" class="control-btn bulk-btn" style="background: #e2e8f0; color: #1e293b;" (click)="navigateToBulkEdit()" *ngIf="isavailablefeature('isUpdate')">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
            </svg>
            Edit All Users
          </button>

          <button type="button" class="control-btn export-btn" (click)="exportToExcel()">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              <polyline points="7 10 12 15 17 10"></polyline>
              <line x1="12" y1="15" x2="12" y2="3"></line>
            </svg>
            Export
          </button>
        </div>
      </div>

      <div class="filter-content" [@slideDown]="isFilterExpanded ? 'expanded' : 'collapsed'" *ngIf="isFilterExpanded">
        <div class="search-filters">
          <!-- Row 1: 4 Fields -->
          <div class="filter-row filter-row-four">
            <div class="input-group">
              <label>Search Employee</label>
              <div class="input-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="11" r="8"></circle>
                  <path d="M21 21l-4.35-4.35"></path>
                </svg>
                <input type="text" placeholder="Search by name..." [(ngModel)]="nameFilter" />
              </div>
            </div>

            <div class="input-group">
              <label>Attendance Id</label>
              <div class="input-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="11" r="8"></circle>
                  <path d="M21 21l-4.35-4.35"></path>
                </svg>
                <input type="text" placeholder="Search by attendance id..." [(ngModel)]="attendanceidFilter" />
              </div>
            </div>

            <div class="input-group">
              <label>Start Date</label>
              <div class="input-wrapper date-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
                <input type="text" placeholder="Select start date" [value]="formatDisplay(startDateFilter)" readonly
                  (click)="openStartPicker()" />
                <input #startPicker type="date" [value]="formatNative(startDateFilter)" (change)="applyStart($event)"
                  class="native-date-input" />
              </div>
            </div>

            <div class="input-group">
              <label>End Date</label>
              <div class="input-wrapper date-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
                <input type="text" placeholder="Select end date" [value]="formatDisplay(endDateFilter)" readonly
                  (click)="openEndPicker()" />
                <input #endPicker type="date" [value]="formatNative(endDateFilter)" (change)="applyEnd($event)"
                  class="native-date-input" />
              </div>
            </div>
          </div>

          <!-- Row 2: 3 Fields -->
          <div class="filter-row filter-row-four">
            <div class="input-group">
              <label>Status Filter</label>
              <div class="input-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
                </svg>
                <select [(ngModel)]="sortType" style="padding-left: 36px">
                  <option value="">Select Filter</option>
                  <option value="absent">Absent</option>
                  <option value="leave">Leaves</option>
                  <option value="late-punchin">Late</option>
                  <option value="punch_in_missing">Punch In Missing</option>
                  <option value="miss-checkout">Punch Out Missing</option>
                  <option value="good-work">Good Work</option>
                  <option value="short-time">Short Time</option>
                </select>
              </div>
            </div>

            <div class="input-group">
              <label>Department</label>
              <div class="input-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
                <select [(ngModel)]="sortdepartment" style="padding-left: 36px">
                  <option value="">Select Department</option>
                  @for (dprt of departments; track dprt) {
                  <option [value]="dprt">
                    {{ dprt }}
                  </option>
                  }
                </select>
              </div>
            </div>

            <div class="input-group">
              <label>Sort By</label>
              <div class="input-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="12" y1="5" x2="12" y2="19"></line>
                  <polyline points="19 12 12 19 5 12"></polyline>
                </svg>
                <select [(ngModel)]="sortBy" style="padding-left: 36px">
                  <option value="">Sort By</option>
                  <option value="name_asc">Name (A-Z Default)</option>
                  <option value="name_desc">Name (Z-A)</option>
                  <option value="date_desc">Non-chronological Order</option>
                  <option value="date_asc">Chronological Order</option>
                </select>
              </div>
            </div>

            <!-- Empty 4th column to maintain alignment -->
            <div class="input-group-empty"></div>
          </div>
        </div>
      </div>

      <!-- counts -->
      <div class="count-cards-row" *ngIf="showUserStats">
        <div class="filter-row filter-automatic">
          <div class="count-card" *ngIf="metadata?.absent_count > 0" [ngClass]="'card-absent'">
            <div class="card-icon">
              <img src="../../../../assets/theme1/total-deduction.png" alt="Absent" />
            </div>
            <div class="card-content">
              <h2>{{ metadata?.absent_count }}</h2>
              <p>Absents</p>
            </div>
          </div>

          <div class="count-card" *ngIf="metadata?.short_time_count > 0" [ngClass]="'card-shorttime'">
            <div class="card-icon">
              <img src="../../../../assets/theme1/goss-salary.png" alt="Short Time" />
            </div>
            <div class="card-content">
              <h2>{{ metadata?.short_time_count }}</h2>
              <p>Short Time</p>
            </div>
          </div>

          <div class="count-card" *ngIf="metadata?.late_punchin_count > 0" [ngClass]="'card-late'">
            <div class="card-icon">
              <img src="../../../../assets/theme1/pay-img.png" alt="Late Punch In" />
            </div>
            <div class="card-content">
              <h2>{{ metadata?.late_punchin_count }}</h2>
              <p>Punch In Late</p>
            </div>
          </div>

          <div class="count-card" *ngIf="metadata?.miss_checkout_count > 0" [ngClass]="'card-missout'">
            <div class="card-icon">
              <img src="../../../../assets/theme1/total-deduction.png" alt="Miss Punch Out" />
            </div>
            <div class="card-content">
              <h2>{{ metadata?.miss_checkout_count }}</h2>
              <p>Punch Out Missing</p>
            </div>
          </div>

          <!-- <div class="count-card" *ngIf="metadata?.overtime_count > 0" [ngClass]="'card-overtime'">
              <div class="card-icon">
                <img src="../../../../assets/theme1/goss-salary.png" alt="Over Time">
              </div>
              <div class="card-content">
                <h2>{{ metadata?.overtime_count }}</h2>
                <p>Over Time</p>
              </div>
            </div> -->

          <div class="count-card" *ngIf="metadata?.leave_count > 0" [ngClass]="'card-leave'">
            <div class="card-icon">
              <img src="../../../../assets/theme1/total-deduction.png" alt="Miss Punch Out" />
            </div>
            <div class="card-content">
              <h2>{{ metadata?.leave_count }}</h2>
              <p>Leave</p>
            </div>
          </div>

        </div>


        
           <!-- Hours Summary Bar -->
      <div class="hours-summary-bar" *ngIf="
          showUserStats &&
          (metadata?.applied_overtime > 0 || metadata?.total_woring_hours > 0 || metadata?.overtime_hours > 0) && metadata?.overtime_days > 2
        " [ngClass]="{ 'dark-mode': selectedMode === 'dark' }">
        <div class="hours-combined-card">
      
          <div class="combined-card-stats">

            <div class="combined-stat overtime-stat" *ngIf="metadata?.overtime_hours > 0 && metadata?.overtime_days > 2">
              <div class="combined-stat-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"></path>
                </svg>
              </div>
              <div class="combined-stat-info">
                <span class="combined-stat-label">Overt Time</span>
                <span class="combined-stat-value">{{ metadata?.overtime_hours | number: "1.0-2"
                  }}<em>hrs</em></span>
              </div>
            </div>


              <div class="combined-stat-divider" *ngIf="
                metadata?.applied_overtime > 0 && metadata?.overtime_hours > 0 && metadata?.overtime_days > 2
              "></div>



            <div class="combined-stat overtime-stat" *ngIf="metadata?.applied_overtime > 0">
              <div class="combined-stat-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"></path>
                </svg>
              </div>
              <div class="combined-stat-info">
                <span class="combined-stat-label">Applied Overtime</span>
                <span class="combined-stat-value">{{ metadata?.applied_overtime | number: "1.0-2"
                  }}<em>hrs</em></span>
              </div>
            </div>



             <div class="combined-stat-divider" *ngIf="
                metadata?.applied_overtime > 0 && metadata?.approve_overtime > 0
              "></div>


            <div class="combined-stat overtime-stat" *ngIf="metadata?.approve_overtime > 0">
              <div class="combined-stat-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"></path>
                </svg>
              </div>
              <div class="combined-stat-info">
                <span class="combined-stat-label">Applied Overtime</span>
                <span class="combined-stat-value">{{ metadata?.approve_overtime | number: "1.0-2"
                  }}<em>hrs</em></span>
              </div>
            </div>



          
            

            <div class="combined-stat-divider" *ngIf="
                metadata?.applied_overtime > 0 &&
                metadata?.total_woring_hours > 0
              "></div>



            <div class="combined-stat total-stat" *ngIf="metadata?.total_woring_hours > 0">
              <div class="combined-stat-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
              </div>
              <div class="combined-stat-info">
                <span class="combined-stat-label">Total Working Hours</span>
                <span class="combined-stat-value">{{ metadata?.total_woring_hours | number: "1.0-2"
                  }}<em>hrs</em></span>
              </div>
            </div>
          </div>
        </div>
      </div>




      </div>

      <div class="modal fade" id="attendanceSet" tabindex="-1" role="dialog" aria-labelledby="attendanceSetCenterTitle"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <div class="modal-header">
              <h5 class="modal-title">
                Are you sure you want to add All Employees Missing Attendance
                row's?
              </h5>
            </div>
            <div class="modal-body">
              <div class="main-body question mt-3 row">
                <img src="../../assets/images/question.jpg" alt="Missing image" />
              </div>
            </div>
            <div class="modal-footer load-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">
                No
              </button>
              <button type="button" class="btn btn-primary" (click)="setattendance()">
                Yes I'm Sure.
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- modal -->
      <div class="modal fade" id="okModal" tabindex="-1" role="dialog" aria-labelledby="okModalCenterTitle"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <div class="modal-header">
              <h5 class="modal-title">Add Attendance Sheet</h5>
            </div>
            <div class="modal-body">
              <div class="main-body mt-3 row">
                <div class="col-6">
                  <input type="file" (change)="onFileSelected($event)" #fileInput />
                  <button class="uploadtn" (click)="fileInput.click()">
                    Choose File
                  </button>
                  <button class="uploadtn">Upload File</button>
                  <!-- <p *ngIf="selectedsheet">{{ selectedsheet.name }}</p> -->
                </div>
                <div class="col-6 dateinput">
                  <input type="date" [(ngModel)]="selectedDate" name="date" />
                </div>
              </div>
            </div>
            <div class="modal-footer load-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="reset()">
                Close
              </button>
              <button type="button" class="btn btn-primary" (click)="this.uploadFile()">
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- attendance set modal -->
      @if (filterType.type != undefined) {
      <div class="route-filter-section">
        <div class="route-name" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
          {{ filterType.type | titlecase }}
          <div class="clear-route" (click)="refreshRoute()">
            <i class="fa fa-close"></i>
          </div>
        </div>
      </div>
      }
     

     
    </div>



 <!-- tabele section -->
      <div class="tablewidth mt-4">
        <table class="bg-white table-container">
          <tr id="tableHead" class="tableHead" [ngClass]="{ 'dark-tr': selectedMode === 'dark' }">
            <th class="pl-3 heading-width">Name</th>
            <th class="pl-3">Date</th>
            <th class="text-center p-0">Check-In</th>
            <th class="text-center p-0">Check-Out</th>
            <th class="text-center p-0">Total Hours</th>
            <th class="text-center p-0 heading-date-width">Status</th>
            @if (isavailablefeature("isUpdate")) {
            <th class="text-center p-0 border-style">Action</th>
            }
          </tr>
          @for (data of pagedData; track data) {
          <tr class="tableData tableDataBorder" [ngClass]="{
                'background-color-red': getStatus(data) === 'Absent',
                weekend: getStatus(data) === 'Weekend',
                paid_leave: getStatus(data) === 'Paid Leave',
                'background-color': getStatus(data) === 'All Good',
                'pre-background': getStatus(data) === 'Pre Joining',
                'post-leaving': getStatus(data) === 'Post Leaving',
                'holiday-color':
                  getStatus(data) !== 'Off Day' &&
                  getStatus(data) !== 'Weekend' &&
                  getStatus(data) !== 'Paid Leave' &&
                  getStatus(data) !== 'Unpaid Leave' &&
                  getStatus(data) !== 'Punch Out Mis.' &&
                  getStatus(data) !== 'Short Hours' &&
                  getStatus(data) !== 'Absent' &&
                  getStatus(data) !== 'Punch In Late' &&
                  getStatus(data) !== 'All Good' &&
                  getStatus(data) !== 'Punch In Mis.' &&
                  getStatus(data) !== 'Post Leaving' &&
                  getStatus(data) !== '',
                'dark-tr-main': selectedMode === 'dark',
              }">
            <td class="pl-3 time-data name-back" [ngClass]="{ 'dark-tr': selectedMode === 'dark' }"
              (click)="attendenceFilterPerUser30days(data.data[0])">
              <span class="custom-tooltip">
                {{ data.data[0].user.first_name }}
                {{ data.data[0].user.last_name }}
                <span class="tooltip-text">
                  <p>
                    Attendance ID:
                    {{ data.data[0].user.attendance_user_id || "null" }}
                  </p>
                  <p>Email: {{ data.data[0].user.email || "null" }}</p>
                  <p>
                    Designation:
                    {{
                    data.data[0].user.designation?.designation_name ||
                    "null"
                    }}
                  </p>
                  <p>
                    Click to Get {{ data.data[0].user.first_name }}
                    {{ data.data[0].user.last_name }} attendance for the past
                    30 days
                  </p>
                </span>
              </span>
            </td>

            <td class="pl-3 time-data">
              {{ data.data[0].date | date: "EEEE, d MMM" }}
            </td>
            <td class="text-center p-0 time-data">
              @for (obj of data.data; track obj) {
              <div class="div" [style.color]="CheckInColor(data)">
                {{ obj.check_in ? obj.check_in : "--" }}
              </div>
              }
            </td>
            <!-- <td class="weekend-status text-center p-0 "
                      *ngIf="isWeekend(data.data[0]) || Holidays(data.data[0]) !== undefined ">
                      <h4>--</h4>
                    </td> -->
            <td class="text-center p-0 time-data" [style.color]="CheckOutColor(data)">
              @for (obj of data.data; track obj) {
              <div class="div">
                {{ obj.check_out ? obj.check_out : "--" }}
              </div>
              }
            </td>
            <!-- <td class="weekend-status text-center p-0 "
                    *ngIf="isWeekend(data.data[0]) || Holidays(data.data[0]) !== undefined">
                    <h4>--</h4>
                  </td> -->
            <td class="text-center p-0 time-data">
              <div class="total-hours" [style.color]="textColorCheck(data)">
                {{
                data.total_hours
                ? (data.total_hours | number: "1.2-2")
                : "--"
                }}
                @if (checkIsTracker(data)) {
                <div class="activity-tracker" data-toggle="modal" data-target="#trackerViewModal"
                  (click)="getTrackerScreenShot(data.data)">
                  <img src="../../assets/attendance/activity.svg" alt="Missing image" />
                </div>
                }
              </div>
              @if (data.data[0].overtime) {
              <div class="overtime">+{{ data.data[0].overtime }}x</div>
              }
            </td>
            <td class="text-center p-0 time-data">
              <div class="statuses">
                @for (status of getStatuses(data); track status) {
                <div class="all-status" [ngClass]="{
                        'holiday-status':
                          status !== 'Off Day' &&
                          status !== 'Weekend' &&
                          status !== 'Paid Leave' &&
                          status !== 'Unpaid Leave' &&
                          status !== 'Punch Out Mis.' &&
                          status !== 'Short Hours' &&
                          status !== 'Absent' &&
                          status !== 'Punch In Late' &&
                          status !== 'All Good' &&
                          status !== 'Applied Leave' &&
                          status !== '',
                        'offday-status': status === 'Off Day',
                        'Paid-status': status === 'Paid Leave',
                        'UnPaid-status-check': status === 'UnPaid Leave',
                        'checkin-status':
                          status === 'Punch Out Mis.' ||
                          status === 'Punch In Mis.',
                        'checkinLate-status': status === 'Punch In Late',
                        'short-status': status === 'Short Hours',
                        'all-status-absent': status === 'Absent',
                        'pre-status': status === 'Pre Joining',
                        'skip-day': status === 'Skip Day',
                        'left-day': status === 'Post Leaving',
                        'good-status': status === 'All Good',
                        'week-status': status === 'Weekend',
                        'pending-leave-badge': status === 'Applied Leave',
                      }">
                  {{ status }}
                </div>
                }
              </div>
            </td>
            @if (isavailablefeature("isUpdate")) {
            <td class="text-center p-0 time-data">
              <div class="btn" data-toggle="modal" data-target="#updateModal" (click)="select(data)">
                <i class="fa fa-edit"></i>
              </div>
            </td>
            }
          </tr>
          @if (data.data[0].update_reason) {
          <tr class="tableData tableDataBorder" [ngClass]="{
                  'background-color': isBothConditionsGreen(data.data[0]),
                }">
            <th class="pl-3 name-back" [ngClass]="{ 'dark-th': selectedMode === 'dark' }">
              Updated Reason:
            </th>
            <td colspan="6" class="reason-text pl-3 time-data" [ngClass]="{
                    'dark-tr-main': selectedMode === 'dark',
                  }">
              {{ data.data[0].update_reason }}
            </td>
          </tr>
          }
          @if (data.data[0].updated_by || data.data[0].update_reason) {
          <tr class="tableData tableDataBorder" [ngClass]="{
                  'dark-tr-main': selectedMode === 'dark',
                  'background-color': isBothConditionsGreen(data.data[0]),
                }">
            <td class="pl-3 time-data name-back" [ngClass]="{ 'dark-th': selectedMode === 'dark' }"></td>
            <td colspan="3"></td>
            @if (data.data[0].updated_by || data.data[0].update_reason) {
            <td class="updated text-right pr-2">Updated By:</td>
            }
            <td class="updated-by">
              <div class="admin-name text-left p-0">
                {{ data.data[0].updated_by }}
              </div>
              @if (!data.data[0].updated_by && data.data[0].update_reason) {
              <div class="admin-name text-left p-0">HR Management</div>
              }
              <div class="updatedate text-left p-0">
                {{ data.data[0].updated_at | date: "yyyy-MM-dd" }}
              </div>
            </td>
            <td></td>
          </tr>
          }
          }
        </table>

        <mat-paginator [length]="userAttendance.length" [pageSize]="pageSize" (page)="onPageChange($event)" [ngClass]="{
            'custom-paginator-theme': selectedMode === 'dark',
          }">
        </mat-paginator>
      </div>

      @if (fullscreenImageUrl) {
      <div class="lightbox">
        <div class="lightbox-content">
          <!-- Button Container (top-right corner) -->
          <div class="lightbox-buttons">
            <a [href]="fullscreenImageUrl" download title="Download" class="download-btn">
              <svg xmlns="http://www.w3.org/2000/svg" height="14" width="10.5" viewBox="0 0 384 512">
                <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
                <path fill="#ffffff"
                  d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z" />
              </svg>
            </a>
            <span class="close-btn" (click)="closeFullscreen()" title="Close">&times;</span>
          </div>
          <!-- Image -->
          <img [src]="fullscreenImageUrl" alt="Fullscreen Screenshot" />
        </div>
      </div>
      }







  </div>
</main>

<!-- Relocated Modals to avoid inheritance of parent-level animations/re-renders -->

<!-- Tracker View Modal -->
<div class="modal right fade" id="trackerViewModal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-slide modal-dialog-scrollable" role="document">
    <div class="modal-content">
      <div class="modal-header-tracker">
        <p class="mb-0">{{ modalTrackerdate | date: "EEEE, d MMM" }}</p>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">
          ×
        </button>
      </div>
      <div class="modal-body">
        <div class="user-summary-card">
          <div class="user-info-wrapper">
            <div class="user-info">
              <div class="user-name">{{ modalName }}</div>
            </div>
            <div class="hours-tracked">
              <div class="graph-icon">
                <img src="../../assets/attendance/graph.svg" alt="i" />
              </div>
              <div>
                <div class="label">
                  Total tracked hours
                  <img class="ml-2 tracker-refresh-icon" src="../../assets/attendance/refresh.svg"
                    alt="Refresh tracked hours" title="Refresh tracked hours"
                    (click)="confirmAndBackfillSingleUser($event)" />
                </div>
                <div class="value large">{{ modaltotalHours }} hrs</div>
              </div>
            </div>
          </div>
          <div class="time-info">
            <div class="time-block">
              <div class="icon-box blue">
                <img src="../../assets/attendance/alarmClockPlus.svg" alt="i" />
              </div>
              <div>
                <div class="label">Start time</div>
                <div class="value">{{ modalcheckIn }}</div>
              </div>
            </div>
            <div class="time-block">
              <div class="icon-box purple">
                <img src="../../assets/attendance/alarmClockMinus.svg" alt="i" />
              </div>
              <div>
                <div class="label">End time</div>
                <div class="value">{{ modalcheckOut }}</div>
              </div>
            </div>
            <div class="time-block">
              <div class="icon-box blue">
                <img src="../../assets/attendance/clockRefresh.svg" alt="i" />
              </div>
              <div>
                <div class="label">Over time</div>
                <div class="value">{{ modalOverTime }}</div>
              </div>
            </div>
          </div>
        </div>
        @if (isLoadingTrackerRecord) {
        <div class="loader-container">
          <div class="spinner"></div>
          <p>Loading activity tracker...</p>
        </div>
        }
        @if (!isLoadingTrackerRecord) {
        <div>
          <div class="screenshots">
            @for (activity of empTrackerRecord; track activity) {
            <div>
              <div class="activity-header">
                <span class="arrow">➜</span>
                <span class="time-range">
                  {{ activity.from }} - {{ activity.to }} ({{
                  activity.totalHours
                  }}
                  hrs)
                </span>
              </div>
              <div class="project-name">
                Project: <strong>{{ activity.note || "-" }}</strong>
              </div>
              <div class="activity-container">
                <div class="screenshot-grid">
                  @for (shot of activity.screenshots; track shot) {
                  <div class="screenshot-box">
                    <div class="screenshot-meta">
                      <span>{{
                        shot.taken * 1000 | date: "shortTime"
                        }}</span>
                    </div>
                    <img [src]="shot.thumbUrl" alt="Screenshot" (click)="openFullscreen(shot.url)"
                      style="cursor: pointer" />
                  </div>
                  }
                </div>
              </div>
            </div>
            }
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>

<!-- Attendance Update Modal -->
<div class="modal fade" id="updateModal" tabindex="-1" role="dialog" aria-labelledby="updateModalCenterTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <form [formGroup]="attendanceForm" (ngSubmit)="updateAttendance()">
        <div class="modal-header">
          <button type="button" id="updateAttendanceCloseBtn" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h5 class="modal-title" id="updateModalLongTitle">
            <img src="../../assets/images/authentication.png" alt="Missing image" />
            Update Attendance
          </h5>
        </div>
        <div class="modal-body">
          <div class="input-field-main">
            <!-- First Row: Check-In and Check-Out -->
            <div class="input-row">
              <div class="input-group-modern half-width">
                <label class="input-label">Check-In Time</label>
                <div class="form-group">
                  <input type="time" class="form-control" formControlName="check_in"
                    (change)="calculateWorkingHours()" />
                </div>
              </div>
              <div class="input-group-modern half-width">
                <label class="input-label">Check-Out Time</label>
                <div class="form-group">
                  <input type="time" class="form-control" formControlName="check_out"
                    (change)="calculateWorkingHours()" />
                </div>
              </div>
            </div>

            <!-- Second Row: Working Hours and Overtime -->
            <div class="input-row">
              <div class="input-group-modern half-width">
                <label class="input-label">Worked Hours</label>
                <div class="form-group">
                  <input type="text" class="form-control no-spin-arrows" placeholder="Enter worked hours (e.g., 8.5)"
                    formControlName="total_hours" />
                </div>
              </div>
              <div class="input-group-modern half-width">
                <label class="input-label">Overtime Hours</label>
                <div class="form-group">
                  <input type="text" class="form-control no-spin-arrows" placeholder="Enter overtime hours (e.g., 2.0)"
                    formControlName="overtime" />
                </div>
              </div>
            </div>

            @if (canEditShiftTimes) {
            <div class="shift-section-header">
              <button type="button" class="btn btn-link shift-toggle-btn" (click)="toggleShiftDetails()">
                {{
                showShiftDetails
                ? "Hide Shift Details"
                : "Show Shift Details"
                }}
              </button>
            </div>

            @if (showShiftDetails) {
            <div class="input-row">
              <div class="input-group-modern half-width">
                <label class="input-label">Shift Start Time</label>
                <div class="form-group">
                  <input type="time" class="form-control" formControlName="shift_start_time" />
                </div>
              </div>
              <div class="input-group-modern half-width">
                <label class="input-label">Shift End Time</label>
                <div class="form-group">
                  <input type="time" class="form-control" formControlName="shift_end_time" />
                </div>
              </div>
            </div>
            <div class="input-row">
              <div class="input-group-modern half-width">
                <label class="input-label">Shift Total Working Hours</label>
                <div class="form-group">
                  <input type="text" class="form-control no-spin-arrows" placeholder="Enter shift total working hours"
                    formControlName="total_working_hours" />
                </div>
              </div>
            </div>
            }
            }

            <!-- Third Row: Update Reason (Full Width) -->
            <div class="input-group-modern full-width">
              <label class="input-label">Comments</label>
              <div class="form-group">
                <textarea class="form-control" rows="3" formControlName="comments"
                  placeholder="Please provide a detailed reason for updating this attendance record (minimum 50 characters)"></textarea>
                @if (
                attendanceForm.get("comments")?.invalid &&
                attendanceForm.get("comments")?.touched
                ) {
                <div>
                  @if (
                  (attendanceForm.get("comments")?.value || "").trim()
                  .length < 50 ) { <p class="alert alert-warning mt-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="me-2">
                      <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"></path>
                      <path d="M12 9v4"></path>
                      <path d="m12 17 .01 0"></path>
                    </svg>
                    <span class="alert-message">Ensure that the entered
                      <strong>Reason</strong> contains a minimum of 50
                      characters.</span>
                    </p>
                    }
                </div>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 6 6 18"></path>
              <path d="m6 6 12 12"></path>
            </svg>
            Close
          </button>
          <button type="submit" class="btn btn-primary" [disabled]="
              attendanceForm.invalid ||
              (attendanceForm.get('comments')?.value || '').trim().length < 50
            ">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
              <polyline points="17,21 17,13 7,13 7,21"></polyline>
              <polyline points="7,3 7,8 15,8"></polyline>
            </svg>
            Update Attendance
          </button>
        </div>
      </form>
    </div>
  </div>
</div>